export default {
  subscriptionPeriod: "setup/subscription-period",
  memberType: "setup/member-type",
  reviewers: "setup/reviewer",
  stages: "application/stage",
  reviewStages: "setup/stage",
};
